var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandHeartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.523438,
    width: 29,
    height: 30,
    rx: 14.5,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8564 8.4225C18.3594 7.8075 18.9969 7.5 19.7689 7.5C20.4135 7.5 20.9519 7.7475 21.3981 8.25C21.8444 8.7525 22.0781 9.3225 22.1064 9.975C22.1064 10.5 21.8727 11.1075 21.3981 11.82C20.9235 12.5325 20.4631 13.125 20.0027 13.6125C19.5423 14.0925 18.8269 14.805 17.8564 15.75C16.8719 14.805 16.1494 14.0925 15.6889 13.6125C15.2285 13.1325 14.761 12.5325 14.2935 11.82C13.826 11.1075 13.6064 10.5 13.6064 9.975C13.6064 9.2925 13.8331 8.7225 14.2935 8.25C14.7539 7.7775 15.3064 7.53 15.951 7.5C16.7089 7.5 17.3394 7.8075 17.8564 8.4225ZM22.1064 20.25V21L16.4398 22.875L11.4814 21.42V22.5H7.23145V14.25H12.8769L17.2402 15.975C18.0335 16.29 18.5648 17.1 18.5648 18H19.9814C21.1573 18 22.1064 19.005 22.1064 20.25ZM10.0648 21V15.75H8.64811V21H10.0648ZM20.6189 19.9275C20.5056 19.68 20.2577 19.5 19.9814 19.5H16.1919C15.8094 19.5 15.4339 19.44 15.0727 19.3125L13.3869 18.72L13.8331 17.295L15.5189 17.8875C15.7314 17.9625 17.1481 18 17.1481 18C17.1481 17.7225 16.9852 17.475 16.7444 17.3775L12.6219 15.75H11.4814V19.875L16.4185 21.3075L20.6189 19.9275Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHeartIcon);
export default __webpack_public_path__ + "static/media/hand-heart-icon.dd30cc304015ddf2881bcadfb0b66707.svg";
export { ForwardRef as ReactComponent };